import React from "react";
import { ExternalLink } from "lucide-react";
import logo from "../../assets/logo.png";

export default function PoweredByPill() {
  return (
    <a
      href="/"
      target="_blank"
      rel="noopener noreferrer"
      className="bg-white/90 border border-indigo-100 shadow-sm rounded-full py-2 pl-3 pr-5 flex items-center gap-3 hover:shadow-md hover:border-indigo-200 transition-all flex-shrink-0"
    >
      <img src={logo} alt="" className="w-8 h-8 rounded-lg" />
      <span className="flex flex-col leading-tight">
        <span className="text-[11px] text-slate-500">Powered by</span>
        <span className="text-base font-semibold text-slate-800">TwoKey</span>
      </span>
      <ExternalLink size={14} className="text-slate-400 ml-3" />
    </a>
  );
}
